import Masonry from "react-masonry-css";
import styled from "styled-components";

import Button from "../../../reusable/button";
const dropdownArrow = require("../../../svg/dropdownArrow.svg");
import { redesignTheme } from "../../../theme/theme";

export const StyledBannerContainer = styled.div`
  background: ${redesignTheme.color.blue500};
  padding: ${redesignTheme.spacing[4]} ${redesignTheme.spacing[6]};
  border-radius: ${redesignTheme.radius.lg};
  display: flex;
  justify-content: space-between;
  margin-bottom: ${redesignTheme.spacing[6]};
`;

export const StyledBannerText = styled.p`
  font-family: ${redesignTheme.fontFamily.interface};
  font-size: ${redesignTheme.fontSize[100]};
  line-height: 24px;
  font-weight: ${redesignTheme.fontWeight.normal};
  color: ${redesignTheme.color.white};
  margin: 0;
  display: block;
`;

export const StyledBannerTextBold = styled(StyledBannerText)`
  font-weight: ${redesignTheme.fontWeight.semibold};
`;

export const StyledButton = styled(Button)`
  margin-left: 0;
  display: inline-block;
`;

export const StyledButtonContainer = styled.div`
  border-top: 1px solid ${redesignTheme.color.grayAlpha100};
  margin-top: 16px;
  padding: 16px 24px 0 24px;
  text-align: right;
  display: flex;
  justify-content: space-between;
`;

export const StyledCircle = styled.div`
  border-radius: 50%;
  height: 12px;
  width: 12px;
  display: inline-block;
  margin-right: ${redesignTheme.spacing[1.5]};
  border: 1px solid ${redesignTheme.color.gray900};
`;

export const StyledCircleGray = styled(StyledCircle)`
  background: ${redesignTheme.color.gray400};
  border: none;
`;

export const StyledCircleGreen = styled(StyledCircle)`
  background: ${redesignTheme.color.green400};
  border: none;
`;

export const StyledCircleRed = styled(StyledCircle)`
  background: ${redesignTheme.color.red400};
  border: none;
`;

export const StyledCircleYellow = styled(StyledCircle)`
  background: ${redesignTheme.color.yellow400};
  border: none;
`;

export const StyledContainer = styled.div`
  padding: ${redesignTheme.spacing[8]} ${redesignTheme.spacing[10]};
  min-height: 100vh;
  background-color: ${redesignTheme.color.gray25};
`;

export const StyledEditButton = styled(Button)`
  margin: auto;
  float: right;
  position: relative;
  right: 0px;
  top: -45px;
  box-shadow: rgb(46 53 56 / 25%) 0px 1px 2px;
`;

export const StyledEmojiSpan = styled.span`
  margin-right: ${redesignTheme.spacing[2.5]};
`;

export const StyledErrorContainer = styled.div`
  padding-left: ${redesignTheme.spacing[6]};
  padding-bottom: ${redesignTheme.spacing[6]};
`;

export const StyledHelperText = styled.span`
  font-weight: ${redesignTheme.fontWeight.normal};
  color: ${redesignTheme.color.gray500};
`;

export const StyledInfoImg = styled.img`
  position: relative;
  top: -2px;
  cursor: pointer;
  display: inline;
`;

export const StyledInput = styled.input`
  &&& {
    width: 100%;
    height: 46px;
    padding: ${redesignTheme.spacing[4]};
    margin-bottom: ${redesignTheme.spacing[4]};
    border: 1px solid ${redesignTheme.color.gray500};
    border-radius: ${redesignTheme.radius.sm};
    font-family: ${redesignTheme.fontFamily.interface};
    color: ${redesignTheme.color.gray900};
    font-size: ${redesignTheme.fontSize[100]};
    box-sizing: border-box;
    ::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    ::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`;

export const StyledLabel = styled.label`
  width: 100%;
  margin-bottom: ${redesignTheme.spacing[1.5]};
  font-family: ${redesignTheme.fontFamily.interface};
  color: ${redesignTheme.color.gray900};
  font-size: ${redesignTheme.fontSize[50]};
  font-weight: ${redesignTheme.fontWeight.medium};
  cursor: text;
`;

export const StyledLink = styled.a`
  color: ${redesignTheme.color.blue500};
  font-weight: ${redesignTheme.fontWeight.medium};
  text-decoration: none;
  &:hover {
    cursor: pointer;
    color: ${redesignTheme.color.blue700};
    text-decoration: none;
  }
`;

export const StyledLinkSpan = styled.span`
  font-weight: ${redesignTheme.fontWeight.normal};
  color: ${redesignTheme.color.gray500};
  line-height: 20px;
  & a {
    color: ${redesignTheme.color.blue500};
    font-weight: ${redesignTheme.fontWeight.medium};
    text-decoration: none;
    &:hover {
      color: ${redesignTheme.color.blue700};
    }
  }
`;

export const StyledMasonry = styled(Masonry)`
  display: flex;
  width: auto;
  margin-left: -24px;

  .grid-column {
    padding-left: ${redesignTheme.spacing[6]};

    > div {
      margin-bottom: ${redesignTheme.spacing[6]};
    }
  }
`;

export const StyledModalBody = styled.div`
  margin: ${redesignTheme.spacing[4.5]} 0;
`;

export const StyledModalContents = styled.div`
  border-top: 1px solid ${redesignTheme.color.grayAlpha100};
  padding: 16px 24px 0 24px;
`;

export const StyledModalText = styled.p`
  font-family: ${redesignTheme.fontFamily.interface};
  font-size: ${redesignTheme.fontSize[100]};
  font-weight: ${redesignTheme.fontWeight.normal};
  margin: 0;
  line-height: 24px;
`;

export const StyledModalSubHeader = styled(StyledModalText)`
  font-size: ${redesignTheme.fontSize[150]};
  font-weight: ${redesignTheme.fontWeight.semibold};
  margin-bottom: ${redesignTheme.spacing[1.5]};
`;

export const StyledPageLoaderContainer = styled.div`
  text-align: center;
  margin-top: 30vh;
  width: 100%;
`;

export const StyledPageHeader = styled.h1`
  flex-basis: 100%;
  font-family: ${redesignTheme.fontFamily.display};
  font-size: ${redesignTheme.fontSize[500]};
  font-weight: ${redesignTheme.fontWeight.extrabold};
  color: ${redesignTheme.color.gray900};
  margin-bottom: ${redesignTheme.spacing[6]};
`;

export const StyledParagraph = styled.p`
  display: block;
  margin-bottom: ${redesignTheme.spacing[1.5]};
  font-family: ${redesignTheme.fontFamily.interface};
  font-size: ${redesignTheme.fontSize[100]};
  color: ${redesignTheme.color.gray900};
  line-height: 20px;
`;

export const StyledParagraphBold = styled(StyledParagraph)`
  font-weight: ${redesignTheme.fontWeight.semibold};
`;

export const StyledPaymentMethodWrapper = styled.div`
  margin-top: ${redesignTheme.spacing[5]};
  padding-top: ${redesignTheme.spacing[4.5]};
  border-top: 1px solid ${redesignTheme.color.grayAlpha300};
`;

export const StyledSelect = styled.select`
  &&& {
    width: 100%;
    height: 46px;
    padding: 0px ${redesignTheme.spacing[3.5]};
    margin-bottom: ${redesignTheme.spacing[1.5]};
    border: 1px solid ${redesignTheme.color.gray500};
    border-radius: ${redesignTheme.radius.lg};
    font-family: ${redesignTheme.fontFamily.interface};
    color: ${redesignTheme.color.gray900};
    font-size: ${redesignTheme.fontSize[100]};
    box-sizing: border-box;
    ::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    ::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    appearance: none;
    -moz-appearance: none; /* Firefox */
    -webkit-appearance: none; /* Safari and Chrome */
    ::-ms-expand {
      display: none; /* IE */
    }
    background-image: url(${dropdownArrow});
    background-repeat: no-repeat;
    background-position: center right 16px;
  }
`;

export const StyledTable = styled.table`
  min-width: 75%;
  background-color: transparent;
  line-height: 1.8em;
  margin-bottom: ${redesignTheme.spacing[4.5]};
`;

export const StyledTableRow = styled.tr`
  height: 32px;
`;

export const StyledTableHeader = styled.th`
  width: 50%;
  vertical-align: top;
  color: ${redesignTheme.color.gray900};
  font-weight: ${redesignTheme.fontWeight.semibold};
  font-size: ${redesignTheme.fontSize[100]};
`;

export const StyledTableData = styled.td`
  font-size: ${redesignTheme.fontSize[100]};
  font-weight: ${redesignTheme.fontWeight.normal};
  color: ${redesignTheme.color.gray900};
  text-align: right;
  vertical-align: top;
`;

export const StyledTextarea = styled.textarea`
  width: 100%;
  height: 128px;
  resize: none;
  margin-top: 0;
  padding: ${redesignTheme.spacing[4.5]};
  font-family: ${redesignTheme.fontFamily.interface};
  color: ${redesignTheme.color.gray900};
  border-radius: ${redesignTheme.radius.lg};
  border: 1px solid ${redesignTheme.color.gray500};
`;
